import React from 'react';

type Props = {
  trackUrlOrId: string; // e.g. "https://open.spotify.com/track/ID" or "spotify:track:ID" or just "ID"
  className?: string;
  theme?: 0 | 1; // optional, Spotify supports theme param (0 = black, 1 = white)
  height: number;
};

function extractTrackId(input: string) {
  // accepts full url, spotify URI, or raw id
  const urlMatch = input.match(/track\/([a-zA-Z0-9]+)/);
  if (urlMatch) return urlMatch[1];
  const uriMatch = input.match(/spotify:track:([a-zA-Z0-9]+)/);
  if (uriMatch) return uriMatch[1];
  // fallback assume it's just the ID
  return input;
}

export default function TrackEmbed({
  trackUrlOrId,
  className,
  theme = 0,
  height,
}: Props) {
  const id = extractTrackId(trackUrlOrId);
  const src = `https://open.spotify.com/embed/track/${id}?utm_source=generator&theme=${theme}`;

  return (
    <iframe
      title={`spotify-track-${id}`}
      src={src}
      className={className}
      allowTransparency={true}
      allow='encrypted-media; clipboard-write'
      style={{ borderRadius: 8 }}
      height={height}
    />
  );
}
